import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { cn } from '../../lib/utils';

export const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
        setMobileMenuOpen(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile overlay */}
      {isMobile && mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-30"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      
      <Sidebar 
        collapsed={isMobile ? !mobileMenuOpen : collapsed} 
        setCollapsed={isMobile ? setMobileMenuOpen : setCollapsed}
        isMobile={isMobile}
        mobileMenuOpen={mobileMenuOpen}
      />
      <Topbar 
        collapsed={collapsed} 
        isMobile={isMobile}
        onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      />
      <main 
        className={cn(
          "pt-16 min-h-screen transition-all duration-300",
          isMobile ? "ml-0" : (collapsed ? "ml-16" : "ml-64")
        )}
      >
        <div className="max-w-[1600px] mx-auto p-3 md:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
